import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { DaterangePickerComponent, DaterangepickerConfig} from 'ng2-daterangepicker';
import {ValidatorUtils} from '../../shared/utils/src/validator.utils';

@Component({
    selector: 'app-datetime-single-picker',
    templateUrl: 'datetime-single-picker.component.html',
})
export class DatetimeSinglePickerComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() date: string;
    @Input() time: string;
    @Input() minMonth: number;
    @Input() maxMonth: number;
    @Input() rsrcId: string;
    @Input() tmznOfs = '+09:00';
    @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() timeChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();

    preDate = '';
    preTime = '';
    calendarOption: any = {};
    timePickerOption: any = {};
    timePickerId = '_timePicker_';

    @ViewChild(DaterangePickerComponent)
    private picker: DaterangePickerComponent;

    constructor(private daterangepickerOptions: DaterangepickerConfig) {
        // datepicker calendar global settings
        this.daterangepickerOptions.skipCSS = true;
    }

    ngOnInit() {
    }

    ngOnChanges(): void {
        if (this.rsrcId !== undefined) {
            this.timePickerId += this.rsrcId;
        }
        this.preDate = this.date;
        this.preTime = this.time;
    }

    ngAfterViewInit() {
        // datetimepicker 초기화
        this.initDateTimePicker();

        // create timepicker
        $('#' + this.timePickerId).timepicker(this.timePickerOption);

        const _x = this;
        $('#' + this.timePickerId).on('changeTime', function() {
            console.log('타임 변경: ', $(this).val());
            _x.timeChange.emit($(this).val());
        });
    }

    ngOnDestroy() {
        $('#' + this.timePickerId).timepicker('remove');
    }

    initDateTimePicker() {
        this.calendarOption = {
            singleDatePicker: true,
            locale: { format: 'YYYY-MM-DD' },
            alwaysShowCalendars: false,
            autoUpdateInput: true,
            startDate: moment(this.date),
            minDate: this.minMonth ? moment().utcOffset(this.tmznOfs).subtract(this.minMonth, 'month').startOf('day') : moment().utcOffset(this.tmznOfs),
            maxDate: this.maxMonth === 0 ? moment().utcOffset(this.tmznOfs) : moment().utcOffset(this.tmznOfs).add(36, 'month').startOf('day')
        };

        this.timePickerOption = {
            timeFormat: 'H:i',
            show2400: true,
            scrollDefault: 'now',
            minTime: '00:00',
            maxTime: '23:59',
            step: 30
        };

        // 스케쥴 팝업 오픈시에 daterangepicker autofocus가는 현상 수정
        $('app-datetime-single-picker input').prop('disabled', true);

        setTimeout( () => {
            $('app-datetime-single-picker input').prop('disabled', false);
        }, 500);
    }

    public selectedDate(event: any) {
        // 캘린더에서 기본 유효성 체크 됨
        this.dateChange.emit(event.start.format('YYYY-MM-DD'));

    }

    public calendarCanceled(e: any) {
        // e.event
        // e.picker
    }

    public calendarApplied(e: any) {
        // e.event
        // e.picker
    }

    onDateChange(event: any) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyDate(event);
        } else {
            if (!ValidatorUtils.checkDate(event.target.value)) {
                this.date = this.preDate;
            }
        }
    }

    onTimeChange(event: any) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyTime(event);
        } else {
            if (ValidatorUtils.checkTime(event.target.value)) {
                this.preTime = this.time = event.target.value;
            } else {
                this.time = this.preTime;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/datetime-single-picker/datetime-single-picker.component.ts